//  ----------      START   IMPORT  BLOCK       ----------
import { useMemo } from 'react';
import { Accordion } from 'react-bootstrap';
import TagDisplay from './TagDisplay';

// Context & Config
import { useLanguage } from '../../../../../API/Context/LanguageContext';
//  ----------      END   IMPORT  BLOCK       ----------

const YearlyDisplay = ({ diagnoses = [], containedAffections = [], handleOpenInHistory }) => {
  // Group diagnosis tags by year
  const groupedTagsByYear = useMemo(() => {
    const yearly_array = {};

    diagnoses.forEach((diagnosis) => {
      if (diagnosis.tags_contained && diagnosis.tags_contained.length > 0) {
        const yearTarget = new Date(diagnosis.creation_date).getFullYear();
        if (!yearly_array[yearTarget]) {
          yearly_array[yearTarget] = [];
        }
        yearly_array[yearTarget].push(diagnosis);
      }
    });

    return yearly_array;
  }, [diagnoses]);

  // Lookup map for tag code -> tag name
  const tagsMap = useMemo(() => {
    return new Map(containedAffections.map((tag) => [tag.id_cie, tag.name]));
  }, [containedAffections]);

  const years = Object.keys(groupedTagsByYear).sort((a, b) => b - a); // Descending year order

  if (years.length === 0) {
    return <p className="text-muted fst-italic py-2 m-0">No pathologic history records found.</p>;
  }

  return (
    <Accordion flush className="w-100">
      {years.map((year, index) => (
        <Accordion.Item eventKey={index.toString()} key={year}>
          <Accordion.Header>{year}</Accordion.Header>
          <Accordion.Body>
            {groupedTagsByYear[year].map((diagnose) =>
              diagnose.tags_contained.map((tag) => {
                const tagName = tagsMap.get(tag);
                return (
                  <TagDisplay
                    key={`${diagnose._id}-${tag}`}
                    diagnose={diagnose}
                    tag={tag}
                    handleOpenInHistory={handleOpenInHistory}
                    name={tagName}
                  />
                );
              })
            )}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default YearlyDisplay;